/**
 *
 *
 *
 *
 *
 *
 **/

let encodeSearchParams = function (obj) {
  const params = [];

  Object.keys(obj).forEach((key) => {
    let value = obj[key];
    // 如果值为undefined我们将其置空
    if (typeof value === 'undefined') {
      value = '';
    }
    // 对于需要编码的文本（比如说中文）我们要进行编码
    params.push([key, encodeURIComponent(value)].join('='));
  });

  return params.join('&');
}


export async function getchanels(vue, opt) {
  let {url, type, data, host = window.Config.channelhost} = opt;
  let _body = null;
  let _contentType = 'application/json';

  if (type.toLocaleUpperCase() === "GET") {
    url = data ? `${url}?${encodeSearchParams(data)}` : `${url}`;
  }

  let _headers = {'Content-Type': _contentType};//设置header值

  return await fetch(host + url, {
    method: type,
    headers: _headers,
    body: _body,
  }).then(res => res.text()).then((res) => {
    if (res) {
      const _returnData = JSON.parse(res);

      if (_returnData.error_code < 0) {
        // console.log(_returnData.error_msg)
        return false
      }
      return _returnData;
    }
    alert(`系统错误${url + JSON.stringify(_body)}`);
  });
}

